import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import EditCategorieApp, { EditCategorieProps, EntityIndKat } from "./editCategorie";
import { IndividualFieldDropDown } from "../editIndividualFields/individualFieldDropDown";
import { Metadata } from "../core/components/commonApp";
import React from "react"
export default class EditCategory extends React.Component<any, any> {
    private categoryInfoRef: CategoryInfo;
    constructor(props) {
        super(props);
    }

    private onSelectChange = (tableName: string) => {
        this.categoryInfoRef.setTableName(tableName);
    }

    render() {
        return (
            <div className="flex-container">
                <IndividualFieldDropDown onSelectChange={this.onSelectChange} translations={this.props.context.translations} url={"EditIndividualFields/GetAllBaseInfos"} />
                <CategoryInfo ref={(ref) => { this.categoryInfoRef = ref }} translations={this.props.context.translations} />
            </div>
        );
    }
}

class CategoryInfo extends React.Component<{ translations: {} }, CategoryInfoState>{
    private gridOptions: kendo.ui.GridOptions;
    private primaryKeyColors = {
        backgroundColor: "#ef5350", //"#04d9ff"
        fontColor: "#000000"
    }
    constructor(props) {
        super(props);
        this.initApp();
        this.state = {
            gridData: [],
            tableName: "",
            selected: null
        }
    }

    setTableName = (tableName: string) => {
        this.setState({ tableName: tableName }, this.loadGridData);
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Id",
                    title: "Id"
                },
                {
                    field: "Tabelle",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Table"]
                },
                {
                    field: "KatName",
                    title: this.props.translations["WebCRM.EditIndividualCategories.CategorieName"]
                },
                {
                    field: "Pos",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Position"]
                }
            ]
        };
    }

    private loadGridData = () => {
        let url = "IndividualCategory/GetByTableName?tableName=" + this.state.tableName;
        HTTPService.get<JsonResultClass<[]>>(url).then((result) => {
            if (result.Code === 0) {
                this.setState({ gridData: result.Data });
            }
        });
    }

    private createGrid = () => {
        let standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: Helper.hasValue(this.state.selected) },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: Helper.hasValue(this.state.selected) }
        ];
        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="tableInfoEditCategoriesGrid"
                    onClickStandardButton={this.onButtonClick}
                    onSelectionChanged={(dataItem) => { this.setState({ selected: dataItem }) }}
                    onDataBound={this.handleDataBound}
                />
            </div>
        );
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: EntityIndKat) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.openEdit(dataItem);
                break;
            case ToolBarStandardButtonType.NEW:
                this.openEdit();
                break;
            case ToolBarStandardButtonType.DELETE:
                DialogHelper.confirm(Config.translations.deleteMessage).then((isOk) => {
                    if (isOk) {
                        HTTPService.post<JsonResultClass>("IndividualCategory/Delete?id=" + dataItem.Id).then((result) => {
                            if (result.Code === 0) {
                                NotificationHelper.showSuccessMessage(result.Message);
                                this.loadGridData();
                            } else {
                                NotificationHelper.showErrorMessage(result.Message);
                            }

                        })
                    }
                })
                break;
        }
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsPrimaryKey) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", this.primaryKeyColors.backgroundColor);
                cell.css("color", this.primaryKeyColors.fontColor);
            }
        }
    }

    private openEdit = (dataItem: EntityIndKat = null) => {
        let isNew = dataItem == null;
        if (isNew) {
            let item: EntityIndKat = {
                Id: null,
                Tabelle: this.state.tableName,
                KatName: "",
                Pos: null,
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: null
            }
            this.openSheet(item);
        }
        else {
            dataItem.RecordRight = { CanRead: true, CanWrite: true };
            this.openSheet(dataItem);
        }
    }

    private openSheet = (entity) => {
        HTTPService.chainBatch
            .add<Metadata>(Helper.getMetaData("editCategorie"))
            .promise()
            .then((result) => {
                const props: EditCategorieProps = {
                    entity: entity,
                    context: {
                        contextType: "editCategorie"
                    },
                    translations: this.props.translations,
                    title: "",
                    metadata: result[0],
                    dataSources: {},
                    isWindow: false
                }
                let sheet = General.Sheet.Manager.createSheet()
                sheet.show(() => {
                    sheet.mountContent(EditCategorieApp, props);
                });
                sheet.bind(SheetEventType.SavedSuccessfully, () => { this.loadGridData() })
            })
    }

    render() {
        return (
            <>
                {!Helper.isNullOrEmpty(this.state.tableName) ? this.createGrid() : null}
            </>
        );
    }
}

interface CategoryInfoState {
    gridData: EntityIndKat[];
    tableName: string;
    selected: EntityIndKat;
}